import { render, staticRenderFns } from "./InternationalMedicine.vue?vue&type=template&id=677cde9e&scoped=true&"
import script from "./InternationalMedicine.vue?vue&type=script&lang=js&"
export * from "./InternationalMedicine.vue?vue&type=script&lang=js&"
import style0 from "./InternationalMedicine.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InternationalMedicine.vue?vue&type=style&index=1&id=677cde9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677cde9e",
  null
  
)

export default component.exports